import { render, staticRenderFns } from "./RadioGroup.vue?vue&type=template&id=60c6039a&"
import script from "./RadioGroup.vue?vue&type=script&lang=js&"
export * from "./RadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/RadioGroup.vue
// module id = null
// module chunks = 